import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "js-main-content" }
const _hoisted_2 = { class: "gfu-layout__main" }
const _hoisted_3 = { class: "_sr-only" }
const _hoisted_4 = {
  key: 0,
  class: "gfu-card-list gfu-card-list--wrap"
}
const _hoisted_5 = ["data-qa"]
const _hoisted_6 = {
  key: 2,
  class: "_flex _jc-c _mt-3"
}
const _hoisted_7 = { class: "_flex _jc-c _mt-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_search_title = _resolveComponent("search-title")
  const _component_filter_buttons = _resolveComponent("filter-buttons")
  const _component_filter_drawer = _resolveComponent("filter-drawer")
  const _component_base_button = _resolveComponent("base-button")
  const _component_empty_state = _resolveComponent("empty-state")
  const _component_box = _resolveComponent("box")
  const _component_processing_button = _resolveComponent("processing-button")
  const _component_load_more_trigger = _resolveComponent("load-more-trigger")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_return_to_element = _resolveComponent("return-to-element")

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_search_title, {
      title: _ctx.Resources.Search.SearchProjectsResultsTitle,
      "total-item-count": _ctx.totalItemCount,
      "has-capped-results": _ctx.hasCappedResults,
      class: "_mb-1 gfu-layout-wrapper",
      "data-qa": "search-result"
    }, null, 8 /* PROPS */, ["title", "total-item-count", "has-capped-results"]),
    _createVNode(_component_filter_buttons, {
      "selected-filters-count": $options.currentFilters.length,
      class: "gfu-layout-wrapper",
      "total-item-count": _ctx.totalItemCount,
      "sort-display-name": $options.sortDisplayName,
      "filters-with-display-names": $options.filtersWithDisplayNames,
      onFiltersOpen: $options.onFiltersOpen,
      onSortOpen: $options.onSortOpen,
      onFilterDelete: $options.onFilterDelete
    }, null, 8 /* PROPS */, ["selected-filters-count", "total-item-count", "sort-display-name", "filters-with-display-names", "onFiltersOpen", "onSortOpen", "onFilterDelete"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.Resources.Search.SearchFiltersHeader), 1 /* TEXT */),
      _createVNode(_component_filter_drawer, {
        schema: _ctx.projectsFiltersSchema,
        "selected-filters": _ctx.selectedFilters,
        "is-drawer-open": _ctx.isFilterDrawerOpen,
        title: _ctx.Resources.Search.SearchFiltersHeader,
        "has-clear-button": "",
        onSearch: $options.onSearch,
        onClose: $options.onFiltersClose,
        onClear: $options.onFilterClear
      }, null, 8 /* PROPS */, ["schema", "selected-filters", "is-drawer-open", "title", "onSearch", "onClose", "onClear"]),
      _createVNode(_component_filter_drawer, {
        schema: _ctx.projectSortSchema,
        "selected-filters": _ctx.selectedFilters,
        "is-drawer-open": _ctx.isSortDrawerOpen,
        title: _ctx.Resources.Search.SearchProjectSortTitle,
        onSearch: $options.onSortChange,
        onClose: $options.onSortClose
      }, null, 8 /* PROPS */, ["schema", "selected-filters", "is-drawer-open", "title", "onSearch", "onClose"]),
      (_ctx.totalItemCount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.projectItems, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.props.projectID,
                class: "gfu-card-list__item gfu-1of1 gfu-1of3--m gfu-1of4--xl",
                "data-qa": `search-result-project:${item.props.projectID}`
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), _mergeProps({ ref_for: true }, item.props), null, 16 /* FULL_PROPS */))
              ], 8 /* PROPS */, _hoisted_5))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : (_openBlock(), _createBlock(_component_box, {
            key: 1,
            class: "_mt-2",
            "data-qa": "search-result:EmptyState"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_empty_state, {
                title: _ctx.Resources.Search.SearchProjectsResultsEmptyStateTitle
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Resources.Search.SearchProjectsResultsEmptyStateParagraph) + " ", 1 /* TEXT */),
                  _createVNode(_component_base_button, {
                    theme: "accent",
                    class: "_mt-3",
                    onClick: $options.onFiltersOpen
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Resources.Search.SearchProjectsResultsEmptyStateParagraphButton), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["title"])
            ]),
            _: 1 /* STABLE */
          })),
      ($options.isMoreVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_processing_button, {
              theme: "outline",
              "is-processing": _ctx.processingMore,
              onClick: $options.onMore
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Resources.Common.LoadMoreButton), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["is-processing", "onClick"])
          ]))
        : _createCommentVNode("v-if", true),
      ($options.canLoadMoreRows)
        ? (_openBlock(), _createBlock(_component_load_more_trigger, {
            key: 3,
            onLoadMore: $options.onMore
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_processing_button, { "is-processing": true }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Resources.Common.LoadMoreButton), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onLoadMore"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode(_component_progress_overlay, {
      visible: _ctx.isProcessing,
      sticky: true
    }, null, 8 /* PROPS */, ["visible"]),
    _createVNode(_component_return_to_element, { "element-id": "magic-anchor-top" })
  ]))
}